import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import { images } from "@/config/images";
import { site } from "@/config/site";

export default function Leather() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main className="pt-24 md:pt-28 pb-16">
        {/* ページタイトル */}
        <div className="bg-secondary-50 border-b border-background-200">
          <div className="max-w-6xl mx-auto px-4 md:px-6 py-10 md:py-14 text-center">
            <p className="inline-flex items-center gap-2 text-xs md:text-sm font-bold text-accent-700 bg-accent-100 rounded-full px-4 py-1.5 mb-4">
              <i className="ri-leaf-line"></i>
              猪革・レザー小物
            </p>
            <h1 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
              猪革・レザー紹介
            </h1>
            <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
              猪の皮も無駄にせず、小物・レザー製品などに活用しています。
            </p>
          </div>
        </div>

        <div className="max-w-4xl mx-auto px-4 md:px-6 mt-12">
          {/* 想い */}
          <div className="text-center mb-10">
            <h2 className="text-lg md:text-2xl font-heading font-bold text-foreground-950 leading-snug">
              お肉だけではなく、皮も大切な命のカケラ。
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-700 leading-relaxed max-w-2xl mx-auto">
              命をいただいた猪の皮を、レザーとして生まれ変わらせ、小物など新しい形へと姿を変えています。
              一つの命から生まれたものを、できるだけ余すことなく次の誰かへつないでいく。それが私たちの取り組みです。
            </p>
          </div>

          {/* レザー小物写真 */}
          <div className="rounded-lg overflow-hidden bg-background-50 border border-background-200">
            <div className="relative aspect-[3/4]">
              <img
                src={images.leather1}
                alt="猪革・レザー小物"
                className="w-full h-full object-contain"
              />
            </div>
          </div>

          {/* Hummingbird × BOARKIN */}
          <div className="mt-12">
            <h3 className="text-lg md:text-xl font-heading font-bold text-foreground-950 flex items-center gap-2">
              <i className="ri-sparkling-2-line text-accent-600"></i>
              Hummingbird × BOARKIN
            </h3>
            <p className="mt-3 text-sm md:text-base text-foreground-700 leading-relaxed">
              猪革を使ったレザー小物を、Hummingbird × BOARKINとして制作しています。
              命を無駄にせず、革も丁寧に活かした作品です。
            </p>
            <div className="mt-5 rounded-lg overflow-hidden bg-background-50 border border-background-200">
              <div className="relative aspect-[3/4]">
                <img
                  src={images.leather2}
                  alt="Hummingbird × BOARKIN レザー小物"
                  className="w-full h-full object-contain"
                />
              </div>
            </div>
          </div>

          {/* LINE問い合わせ */}
          <div className="mt-12 bg-primary-500 rounded-lg p-8 md:p-10 text-center">
            <h2 className="text-lg md:text-2xl font-heading font-bold text-background-50">
              レザー小物についてのお問い合わせ
            </h2>
            <p className="mt-3 text-sm md:text-base text-background-50/90">
              レザー小物についてのお問い合わせは、公式LINEよりお気軽にご連絡ください。
            </p>
            <a
              href={site.lineUrl || "/contact"}
              target={site.lineUrl ? "_blank" : undefined}
              rel={site.lineUrl ? "noopener noreferrer" : undefined}
              className="inline-flex items-center justify-center gap-2 mt-6 bg-background-50 text-primary-700 text-base font-bold px-8 py-3.5 rounded-md whitespace-nowrap transition-colors hover:bg-background-100"
            >
              <i className="ri-line-line"></i>
              公式LINEからお問い合わせ
            </a>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}